import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';

type DatePickerFormFieldName = 'datum' | 'wiederholungBis';

interface DatePickerFormFieldProps {
  name: DatePickerFormFieldName;
}

export function DatePickerFormField({ name }: DatePickerFormFieldProps) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  const label =
    name === 'datum'
      ? t('domain.termine.sheet.fields.am')
      : t('domain.termine.sheet.fields.laufzeitBis');

  return (
    <form.AppField name={name}>
      {(field) => <field.DatePicker label={label} />}
    </form.AppField>
  );
}
